import { getAriaProps } from "PFCore/helpers/get_aria_props";
import React, { AriaAttributes, forwardRef } from "react";

import { Pill, PillProps } from "../pill/pill";
import { Typography } from "../typography";
import css from "./key_value_pill.module.scss";

type KeyValuePillProps = {
  keyText: string;
  value: string;
} & Pick<PillProps, "onDelete" | "deleteTitle" | "title" | "qaId"> &
  AriaAttributes;

export const KeyValuePill = forwardRef<HTMLDivElement, KeyValuePillProps>(
  ({ keyText, value, onDelete, deleteTitle, title, qaId, ...props }, ref) => {
    const { ariaProps } = getAriaProps(props);

    return (
      <Pill
        ref={ref}
        kind="regular"
        classes={{ root: css.root }}
        onDelete={onDelete}
        deleteTitle={deleteTitle}
        qaId={qaId}
        {...ariaProps}
      >
        <div className={css.content} title={title}>
          <Typography variant={"labelRegular"} tag="span" className={css.keyText} textOverflow="clip">
            {keyText}
          </Typography>
          <Typography variant={"bodyBold"} tag="span" className={css.valueText} textOverflow="clip">
            {value}
          </Typography>
        </div>
      </Pill>
    );
  }
);

KeyValuePill.displayName = "KeyValuePill";
